import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import { Fetcher } from "../components/Fetcher";
import { CurrentUser } from "../models/User";
import { getCurrentUserDetails } from "../services/api/user.api";

const useStyles = makeStyles((theme) => ({
	list: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[1],
		margin: theme.spacing(4, 0, 2),
		maxWidth: theme.breakpoints.values.sm,
	},
	form: {
		display: "inline",
		marginLeft: 16,
	},
}));

const renderPage = (data: CurrentUser, classes: Record<any, string>) => {
	return (
		<div>
			<Typography variant="h5">
				<span>{data.userName}</span>
				<form action="/Account/SignOut" method="post" className={classes.form}>
					<Button variant="outlined" type="submit">
						Sign Out
					</Button>
				</form>
			</Typography>

			<List
				data-testid="current-user-global-roles"
				subheader={<ListSubheader>Global Roles {data.globalRoles.length === 0 && "(None)"}</ListSubheader>}
				className={classes.list}
			>
				{data.globalRoles.map((r) => (
					<ListItem key={r}>
						<ListItemText primary={r} />
					</ListItem>
				))}
			</List>

			<List
				data-testid="current-user-product-roles"
				subheader={<ListSubheader>Product Roles {data.productRoles.length === 0 && "(None)"}</ListSubheader>}
				className={classes.list}
			>
				{data.productRoles.map((r) => (
					<ListItem key={r.productId}>
						<ListItemText
							primary={r.roleName}
							secondary={
								<span>
									<b>{r.productName}</b> ({r.productId})
								</span>
							}
						/>
					</ListItem>
				))}
			</List>
		</div>
	);
};

/**
 * Page to fetch and display info for the logged in user
 */
export const CurrentUserPage = () => {
	const classes = useStyles();
	return (
		<div data-testid={"current-user-page"}>
			<Fetcher action={getCurrentUserDetails()}>{(response) => renderPage(response && response.data, classes)}</Fetcher>
		</div>
	);
};
